const initialState = {
    items: [],
    single: {},
    refresh: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'GLOBALS_RESET':
            return initialState;

        case 'GET_GLOBALS':
            return {
                ...state,
                items: action.payload.global
            };
            
        case 'GLOBAL_FIELD_GET_SINGLE_SUCCESS':
            return {
                ...state,
                single: action.payload.data
            };
            
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/core/admin/store/reducers/global.js